import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import Service from './change-plan.service'
import Form from './form.component'
import FormHelper from '../../../../../../utils/FormHelper'
import './change-plan.styles.scss'
import Dialog from '../../../../../../components/dialog/dialog.component'
import Loading from '../../../../../../components/loading/loading.component'

class ChangePlan extends React.Component {

    constructor(props) {
        super(props)
        this.service = Service(this)
        this.state = this.service.getDefaultState()
    }

    componentDidMount() {
        this.service.loadLocationPlans()
    }

    onSubmit = (e) => {
        e.preventDefault()
        this.service.isValid() && this.service.save()
    }

    render() {
        return (
            <div className="change-plan card">
                {(this.state.saving || this.state.loadLocationPlans) && <Dialog><Loading /></Dialog>}
                <div className="header">
                    <h4>Change Plan</h4>
                </div>
                <div className={"flag " + this.state.flag.type}>
                    {this.state.flag.text}
                </div>
                <Form {...this.state} onChange={FormHelper(this).onChange} onSubmit={this.onSubmit} onCancel={this.props.onClose}/>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps)(withRouter(ChangePlan))